import { modalType, SettingName } from '../../Types';
export const PlayerUIState = {
    isSeeking: false,
    isDragSeeking: false,
    isAnyModalOpen: false,
    isOnLiveEdge: true,
    [modalType.settings]: {
        isOpen: false,
        setting: SettingName.AudioSubtitles,
    },
    [modalType.episodes]: {
        isOpen: false,
    },
    [modalType.channels]: {
        isOpen: false,
    },
    [modalType.related]: {
        isOpen: false,
    },
    relativeSeekValue: null,
    uiDisplayed: true,
    uiHidden: false,
    bingeWatchingOverlay: {
        isOpen: false,
        isDismissed: false,
        remainingTime: -1,
    },
    TVseekingEnabled: false,
};
//# sourceMappingURL=state.js.map